import { motion } from "framer-motion";

interface Props {
	btnText: string;
	id?: string;
	topNode?: React.ReactNode;
	onClick?: () => void;
}

export default function InviteBtn(props: Props) {
	return (
		<footer className="fixed bottom-0 left-1/2 z-20 w-full max-w-screen-sm -translate-x-1/2 bg-[#200D60] px-4 pb-[calc(14px+env(safe-area-inset-bottom))] pt-3.5">
			{props.topNode ? <div className="mb-3">{props.topNode}</div> : null}

			<motion.button
				type="button"
				className="block h-[54px] w-full rounded-[28px] border-0 bg-[linear-gradient(100deg,#fff7bf_0%,#ffcf00_92%)] text-center text-[17px] font-black leading-[54px] text-black shadow-[0_5px_0_#090016]"
				id={props.id}
				onClick={props.onClick}
				whileTap={{ scale: 0.98 }}
			>
				{props.btnText}
			</motion.button>
		</footer>
	);
}
